import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"error\"><path d=\"M12 4a8 8 0 110 16 8 8 0 010-16zm0 1.067a6.933 6.933 0 100 13.866 6.933 6.933 0 000-13.866z\" /><rect width=\"1\" height=\"10\" x=\"11.389\" y=\"7\" rx=\".5\" transform=\"rotate(-45 11.89 12)\" /><rect width=\"1\" height=\"10\" x=\"11.389\" y=\"7\" rx=\".5\" transform=\"scale(1 -1) rotate(-45 -17.081 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol